import React from 'react';

const testimonialsData = [
  {
    image: "",
    name: "Ryan Florence",
    title: "CEO of Furnish",
    text: "Working with Lizay Company was a game-changer for our business. Their expertise and dedication helped us reach new heights."
  },
  {
    image: "",
    name: "Sarah M.",
    title: "CTO at FitWave",
    text: "Working with Lizay Company has been a game-changer for our business. Their team is exceptionally talented and provided us with a top-notch website."
  },
  {
    image: "",
    name: "James R.",
    title: "Developer and Educator",
    text: "Lizay Company turned our vision into reality. The user experience of our site improved dramatically."
  }
];

// Fonction pour générer les initiales si pas de photo
const getInitials = (name) => {
  return name
    .split(' ')
    .map((n) => n[0])
    .join('')
    .toUpperCase();
};

const Testimonials = () => {
  return (
    <section className="text-black bg-gray-50 dark:bg-slate-950 py-20">
      <div className="container mx-auto px-6">
        {/* En-tête */}
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold text-blue-600 mb-4">Témoignages</h1>
          <p className="text-lg leading-relaxed text-black dark:text-gray-50 xl:w-2/3 mx-auto">
            Ce que nos clients disent à propos de nous.
          </p>
        </div>

        {/* Grille des témoignages */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonialsData.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white dark:bg-gray-800 p-8 rounded-lg shadow-md hover:shadow-xl transition-all"
            >
              <div className="flex items-center mb-4">
                {testimonial.image ? (
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-16 h-16 rounded-full shadow-lg object-cover"
                  />
                ) : (
                  <div className="w-16 h-16 flex items-center justify-center rounded-full shadow-lg bg-blue-600 text-white text-xl font-bold">
                    {getInitials(testimonial.name)}
                  </div>
                )}
                <div className="ml-4">
                  <h3 className="text-xl font-semibold text-gray-900 dark:text-white">
                    {testimonial.name}
                  </h3>
                  <p className="text-gray-500 dark:text-gray-400">{testimonial.title}</p>
                </div>
              </div>
              <p className="text-gray-700 dark:text-gray-300 italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
